import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MultiControllerService } from '../multi-controller.service';

@Component({
    selector: 'ms-multi-example-column',
    templateUrl: './multi-example-column.component.html',
    styleUrls: ['./multi-example-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MultiExampleColumnComponent {
  /** Первое число. */
  @Input('first')
  public firstNumber: number | string;

  /** Второе число. */
  @Input('second')
  public secondNumber: number | string;

  /** Операция. */
  @Input()
  public operation: string = '✕';

  /** Цвет текста. */
  @Input('color')
  public textColor: string;

  /** Начертание текста. */
  @Input()
  public fontFamily: string;

  constructor(public multiControllerService: MultiControllerService) {
  }
}
